<template>
  <div>
    <div class="flex justify-start items-center mb-10px">
      <el-select v-model="evaluateMethod" size="mini" class="mr-10px" disabled>
        <el-option
          v-for="item in evaluateMethodsList"
          :key="item.code"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>
      <el-button class="mr-10px" @click.stop="open" size="small" :disabled="isDisabled"
        >{{ formData.isRiskDirectJudgment ? '取消' : '启用' }}风险直判</el-button
      >
      <el-select
        v-model="formData.riskDirectJudgmentType"
        size="mini"
        @change="getResult"
        :disabled="isDisabled || !formData.isRiskDirectJudgment"
      >
        <el-option
          v-for="item in riskList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div>
      <el-row :gutter="10" v-if="evaluateMethod === 0">
        <el-col :span="12" class="mb-10px">
          <p class="font-bold text-base py-10px">事故事件发生的可能性（L）判定准则</p>
          <el-table :data="lslTable" border stripe>
            <el-table-column label="分值" prop="lData" show-overflow-tooltip width="80">
              <template slot-scope="scope">
                <span>{{ scope.row.lData }}</span>
              </template>
            </el-table-column>
            <el-table-column label="请选择事故发生的可能性" prop="lData" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.lData"
                  size="mini"
                  class="w-full"
                  :disabled="formData.isRiskDirectJudgment || isDisabled"
                >
                  <el-option
                    v-for="item in lslList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="12" class="mb-10px">
          <p class="font-bold text-base py-10px">发生事故事件偏差产生的后果严重性（S）判定准则</p>
          <el-table :data="lssTable" border stripe>
            <el-table-column label="分值" prop="lData" show-overflow-tooltip width="80">
              <template slot-scope="scope">
                <span>{{ scope.row.lData }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="事故事件偏差产生的后果严重性"
              prop="lData"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.lData"
                  size="mini"
                  class="w-full"
                  :disabled="formData.isRiskDirectJudgment || isDisabled"
                >
                  <el-option
                    v-for="item in lssList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-else>
        <el-col :span="12" class="mb-10px">
          <p class="font-bold text-base py-10px">事故事件发生的可能性（L）判定准则</p>
          <el-table :data="leclTable" border stripe>
            <el-table-column label="分值" prop="lData" show-overflow-tooltip width="80">
              <template slot-scope="scope">
                <span>{{ scope.row.lData }}</span>
              </template>
            </el-table-column>
            <el-table-column label="请选择事故发生的可能性" prop="lData" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.lData"
                  size="mini"
                  class="w-full"
                  :disabled="formData.isRiskDirectJudgment || isDisabled"
                >
                  <el-option
                    v-for="item in leclList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="12" class="mb-10px">
          <p class="font-bold text-base py-10px">人员暴露与危险环境的频率（E）判定准则</p>
          <el-table :data="leceTable" border stripe>
            <el-table-column label="分值" prop="lData" show-overflow-tooltip width="80">
              <template slot-scope="scope">
                <span>{{ scope.row.lData }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="事故事件偏差产生的后果严重性"
              prop="lData"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.lData"
                  size="mini"
                  class="w-full"
                  :disabled="formData.isRiskDirectJudgment || isDisabled"
                >
                  <el-option
                    v-for="item in leceList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="12" class="mb-10px">
          <p class="font-bold text-base py-10px">发生事故可能造成的后果（C）判定准则</p>
          <el-table :data="leccTable" border stripe>
            <el-table-column label="分值" prop="lData" show-overflow-tooltip width="80">
              <template slot-scope="scope">
                <span>{{ scope.row.lData }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="请选择事故发生的可能性"
              prop="lData"
              show-overflow-tooltip
              :disabled="formData.isRiskDirectJudgment || isDisabled"
            >
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.lData"
                  size="mini"
                  class="w-full"
                  :disabled="formData.isRiskDirectJudgment || isDisabled"
                >
                  <el-option
                    v-for="item in leccList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-form ref="form" label-width="120px" :rules="rules" :model="formData" class="mt-10px">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item :label="`${evaluateMethod === 0 ? 'R' : 'D'}风险值`" prop="dRiskValue">
              <el-input v-model="formData.dRiskValue" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="评价级别" prop="evaluationLevel">
              <el-input v-model="formData.evaluationLevel" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="管控级别" prop="controlLevel">
              <el-input v-model="formData.controlLevel" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="风险颜色" prop="riskColor">
              <el-input v-model="formData.riskColor" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { SourcesDangerRecognitionRiskRatingApi } from '@wiz-api/double-prevention-management'
import {
  riskList,
  lslList,
  lssList,
  lsLevel,
  lecLevel,
  leclList,
  leceList,
  leccList,
} from '@/components/safety/enumField/enumTagType'
import utils from '@/components/safety/enumField/utils'

const sourcesDangerRecognitionRiskRatingApi = new SourcesDangerRecognitionRiskRatingApi()

export default {
  name: 'risk-evaluate',
  props: {
    projectId: {
      type: String,
      default: null,
    },
    taskId: {
      type: String,
      default: null,
    },
    identifyId: {
      type: String,
      default: null,
    },
    evaluateMethod: {
      type: Number,
      default: 0,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: null,
      rules: {
        dRiskValue: [{ required: true, message: '风险值不能为空', trigger: ['change', 'blur'] }],
        // 评价级别
        evaluationLevel: [
          { required: true, message: '评价级别不能为空', trigger: ['change', 'blur'] },
        ],
        // 管控级别
        controlLevel: [
          { required: true, message: '管控级别不能为空', trigger: ['change', 'blur'] },
        ],
        // 风险颜色
        riskColor: [{ required: true, message: '风险颜色不能为空', trigger: ['change', 'blur'] }],
      },
      formData: {
        id: null,
        recognitionRelationalId: this.identifyId,
        sourcesDangerRecognitionPlanTaskId: this.taskId,
        // 风险评级方法类型
        riskRatingMethodType: this.evaluateMethod,
        // 是否启动风险直判
        isRiskDirectJudgment: false,
        // 启动风险直判的风险类型
        riskDirectJudgmentType: null,
        // 风险评估的分值集合
        riskRatingPointsCollection: '',
        // D风险值
        dRiskValue: '',
        // 评价级别
        evaluationLevel: '',
        // 管控级别
        controlLevel: '',
        // 风险颜色
        riskColor: '',
      },
      evaluateMethodsList: [],
      riskList,
      lslList,
      lssList,
      lsLevel,
      lecLevel,
      leclList,
      leceList,
      leccList,
      lslTable: [
        {
          lData: null,
        },
      ],
      leccTable: [
        {
          lData: null,
        },
      ],
      leclTable: [
        {
          lData: null,
        },
      ],
      leceTable: [
        {
          lData: null,
        },
      ],
      lssTable: [
        {
          lData: null,
        },
      ],
    }
  },
  mounted() {
    utils.getDataCategory(
      ['DoublePreventionManagement.DataCategory.EvaluateMethods'],
      ['evaluateMethodsList'],
      this
    )
    // 获取详情，存在id则请求接口，获取详情
    if (this.projectId) {
      this.getTableData()
      this.getDetail()
    } else {
      this.initForm()
      this.initTable()
    }
  },
  computed: {
    // ls 计算结果
    isLsTableChange() {
      const { lssTable, lslTable } = this
      return { lssTable, lslTable }
    },
    // lec 计算结果
    isLecTableChange() {
      const { leclTable, leceTable, leccTable } = this
      return { leclTable, leceTable, leccTable }
    },
  },
  watch: {
    isLsTableChange: {
      handler(newVal, oldVal) {
        if (newVal.lssTable[0].lData && newVal.lslTable[0].lData) {
          this.formData.dRiskValue =
            Math.round(newVal.lslTable[0].lData * newVal.lssTable[0].lData * 100) / 100
          // 计算结果
          this.getCount(this.formData.dRiskValue, 'ls')
          this.formData.riskRatingPointsCollection = `${newVal.lssTable[0].lData},${newVal.lslTable[0].lData}`
        }
      },
      deep: true,
    },
    isLecTableChange: {
      handler(newVal, oldVal) {
        if (newVal.leclTable[0].lData && newVal.leceTable[0].lData && newVal.leccTable[0].lData) {
          this.formData.dRiskValue =
            Math.round(
              newVal.leclTable[0].lData *
                newVal.leceTable[0].lData *
                newVal.leccTable[0].lData *
                100
            ) / 100

          // 计算结果
          this.getCount(this.formData.dRiskValue, 'lec')
          this.formData.riskRatingPointsCollection = `${newVal.leclTable[0].lData},${newVal.leceTable[0].lData},${newVal.leccTable[0].lData}`
        }
      },
      deep: true,
    },
  },
  methods: {
    // 获取详情
    async getDetail() {
      const [err, res] = await sourcesDangerRecognitionRiskRatingApi.get(this.projectId)
      if (!err) {
        this.formData = res
        this.id = res.id
        this.getTableData()
      }
    },
    // 计算表格中选择的准则
    getTableData() {
      // 未开启风险直判
      let riskRatingPointsCollection = []
      if (!this.formData.isRiskDirectJudgment) {
        const tableNameLs = ['lslTable', 'lssTable']
        const tableNameLec = ['leclTable', 'leceTable', 'leccTable']
        riskRatingPointsCollection = this.formData.riskRatingPointsCollection.split(',')
        // ls
        if (riskRatingPointsCollection && riskRatingPointsCollection.length === 2) {
          _.forEach(tableNameLs, (item, index) => {
            this[item][0].lData =
              riskRatingPointsCollection[index] && Number(riskRatingPointsCollection[index])
          })
        } else if (riskRatingPointsCollection && riskRatingPointsCollection.length === 3) {
          // lec
          _.forEach(tableNameLec, (item, index) => {
            this[item][0].lData =
              riskRatingPointsCollection[index] && Number(riskRatingPointsCollection[index])
          })
        }
      } else {
        this.getResult()
      }
    },
    // 表单校验
    validate() {
      let flag = false
      this.$refs.form.validate((valid) => {
        flag = valid
      })
      return flag
    },
    // 启用/取消风险直判
    open() {
      this.formData.isRiskDirectJudgment = !this.formData.isRiskDirectJudgment
      // 启用风险直判
      if (this.formData.isRiskDirectJudgment) {
        this.formData.riskDirectJudgmentType = 0
        this.initTable()
        this.getResult()
      } else {
        this.formData.riskDirectJudgmentType = null
        this.initForm()
      }
      this.formData.riskRatingPointsCollection = ''
      this.initTable()
    },
    // 风险直判-获取结果
    getResult() {
      const resData = _.filter(this.lsLevel, (item) => {
        return item.value === this.formData.riskDirectJudgmentType
      })
      this.formData.dRiskValue = 'N/A'
      this.formData.controlLevel = resData[0].level
      this.formData.evaluationLevel = resData[0].deep
      this.formData.riskColor = resData[0].color
    },
    /**
     * 计算结果
     * @param {*} val 值
     * @param {*} type ls或者lec
     */
    getCount(val, type) {
      let resData = {}
      if (type === 'ls') {
        resData = _.find(this.lsLevel, (item) => {
          return Number(val) >= item.min && Number(val) <= item.max
        })
      } else {
        resData = _.find(this.lecLevel, (item) => {
          return Number(val) >= item.min && Number(val) <= item.max
        })
      }
      this.formData.controlLevel = resData.level
      this.formData.evaluationLevel = resData.deep
      this.formData.riskColor = resData.color
    },
    // 初始化准则
    initTable() {
      const tableName = ['lslTable', 'lssTable', 'leccTable', 'leclTable', 'leceTable']
      _.forEach(tableName, (item) => {
        this[item][0].lData = null
      })
    },
    // 初始化表单数据
    initForm() {
      this.formData = {
        id: this.id,
        recognitionRelationalId: this.identifyId,
        sourcesDangerRecognitionPlanTaskId: this.taskId,
        // 风险评级方法类型
        riskRatingMethodType: this.evaluateMethod,
        // 是否启动风险直判
        isRiskDirectJudgment: false,
        // 启动风险直判的风险类型
        riskDirectJudgmentType: null,
        // 风险评估的分值集合
        riskRatingPointsCollection: '',
        // D风险值
        dRiskValue: '',
        // 评价级别
        evaluationLevel: '',
        // 管控级别
        controlLevel: '',
        // 风险颜色
        riskColor: '',
      }
    },
  },
}
</script>

<style lang="less" scoped></style>
